<template>
    <transition name="fade" class="fade">
        <div v-show="show" class="confirm-wrap fixed-100">
            <div class="bg fixed-100"></div>
            <div class="confirm-container center-middle">
                <div class="confirm-content" v-html="content"></div>
                <div>
                    <div
                        class="primary-btn white"
                        :class="{ 'button-assertive': cancelTheme == 'assertive', 'button-positive': cancelTheme == 'positive' }"
                        href="javascript:void(0)"
                        @click="$emit('CancelEvent')"
                    >
                        {{ cancelText }}
                    </div>
                    <div
                        class="primary-btn"
                        :class="{ 'button-assertive': okTheme == 'assertive', 'button-positive': okTheme == 'positive' }"
                        href="javascript:void(0)"
                        @click="$emit('OkEvent')"
                    >
                        {{ okText }}
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            default: '提示'
        },
        okText: {
            type: String,
            default: '确定'
        },
        okTheme: {
            type: String,
            default: 'assertive'
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        cancelTheme: {
            type: String,
            default: 'positive'
        },
        closeButton: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false
        }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.confirm-wrap {
    z-index: 9999;
    font-size: 30px;
}
.confirm-wrap .bg {
    background: $black;
    z-index: 10;
    opacity: 0.9;
}
.confirm-container {
    background: $white;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 11;
    padding: 20px;
    border: 1px solid $gray;
    border-radius: 4px;
    transform: translate(-50%, -50%);
    text-align: center;
}
.confirm-content {
    margin: 40px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/confirm/confirm.vue